import React from 'react';
import PropTypes from 'prop-types';
import './css/OrderStageBadge.css';
import { getOrderStageData } from '../../../Utils/CommonUtils';
import {
  STAGE_PREFIX,
  STAGE_HINT,
} from '../../../Utils/Constants/AdminConstants';

function OrderStageBadge(props) {
  const { order } = props;
  const stage = getOrderStageData(order);

  return (
    <span className="ostb_badge" title={STAGE_HINT}>
      <span
        className="ostb_marker"
        style={{ backgroundColor: stage.color }}
      />
      <span className="ostb_prefix">{STAGE_PREFIX}</span>
      {stage.title}
    </span>
  );
}

OrderStageBadge.propTypes = {
  order: PropTypes.instanceOf(Object).isRequired,
};

export default OrderStageBadge;
